//====================================================
//  Function: Pie
//====================================================
function fn_components_pie(){
	if ($( '.js-pie' ).length){
		if ($window.width() < bp_xsmall){
			var size = 80;
			var width = 8;
		} else {
			var size = 120;
			var width = 12;
		}

		$( '.js-pie' ).easyPieChart({
			animate: 1000,
			lineWidth: width,
			size: size,
			lineCap: 'square',
			trackColor: false,
			scaleColor: false,
			barColor: '#124072',
			onStep: function(value) {
				$(this).find('span').text(Math.round(value));
			},
			onStop: function(value, to) {
				$(this).find('span').text(Math.round(to));
			}
		});
	}
}